<template>
    <section id="after-movies">
        <div class="secondary-heading text-center">ESSENS KICK OFF</div>
        <h1 class="text-center mb-5"> {{ $t('webVideo') }} </h1>
        <div id="after-movies-container" class="container-fluid container-xxl px-5 position-relative">
         <div class="embed-responsive embed-responsive-16by9">
                <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/ABj_vHD_4Ns?si=CunQTpg1ozHsrIlV" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        </div>
        </div>
    </section>
</template>

<style>
    #after-movies {
        background-color: var(--white-bg);
    } 
</style>